import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const addUserDetailsClient = async (user) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.addUserDetails()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
    });

    let parsedBody = null;
    try {
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            parsedBody = await res.json();
        } else {
            const text = await res.text();
            parsedBody = text ? { message: text } : null;
        }
    } catch (e) {
        parsedBody = null;
    }

    if (!res.ok) {
        const msg =
            parsedBody?.message ||
            parsedBody?.error ||
            'Add user details request failed';
        return { error: true, message: msg, status: res.status, data: parsedBody || [] };
    }
    return { status: res.status, data: parsedBody };
};

export default addUserDetailsClient;
